import { RouteRecordRaw } from 'vue-router';
import * as CONST from '@/const'

let routes: RouteRecordRaw[] = [
    {
        path: '/catalogue',
        name: 'catalogue',
        component: () => import("./views/catalogue.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/catalogue/qrPrinting',
        name: 'catalogue_qrPrinting',
        component: () => import("./views/qrPrinting.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
    {
        path: '/catalogue/:categoryIdentifier',
        name: 'catalogueCategory',
        component: () => import("./views/catalogueCategory.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User],
        }
    },
    {
        path: '/catalogue/:categoryIdentifier/:productIdentifier',
        name: 'catalogueProduct',
        component: () => import("./views/catalogueProduct.vue"),
        meta: {
            allowedRoles: [CONST.AppRoles.User]
        }
    },
];

export default routes;
